import a from "./ghl-ui.es1388.js";
function e(t) {
  return a(this.__data__, t) > -1;
}
export {
  e as default
};
